module.exports = __webpack_public_path__ + "public/img/lan_3.bdc83375.png";